import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import SendNotification from './SendNotification';
import NotificationHistory from './NotificationHistory';
import './NotificationManagement.scss';

const NotificationManagement = ({ activeView = 'send-notification' }) => {
    const { t } = useLanguage();

    const renderActiveView = () => {
        switch (activeView) {
            case 'send-notification':
                return <SendNotification />;
            case 'notification-history':
                return <NotificationHistory />;
            default:
                return <SendNotification />;
        }
    };

    return (
        <div className="notification-management">
            {renderActiveView()}
        </div>
    );
};

export default NotificationManagement;